import { Table, ScrollArea, Badge } from "@mantine/core";
import { TAttempt } from "../../types/Aula";
import { useTranslation } from "react-i18next";

export const AttemptHistoryGrid = ({ attempts }: { attempts: TAttempt[] }) => {
  const { t } = useTranslation();

  return (
    <>
      {attempts.length > 0 && (
        <ScrollArea h={160} type="auto">
            <Table highlightOnHover>
                <Table.Thead>
                <Table.Tr>
                    <Table.Th></Table.Th>
                    <Table.Th>{t("quiz.attempt")}</Table.Th>
                    <Table.Th>{t("duration")}</Table.Th>
                    <Table.Th>{t("status.title")}</Table.Th>
                </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                {attempts.map((attempt, index) => (
                    <Table.Tr key={index}>
                      <Table.Td fw={500}>
                        {index === 0 ? t("mostRecent") : ""}
                      </Table.Td>
                      <Table.Td>{attempts.length - index}</Table.Td>
                      <Table.Td>
                        {new Date(attempt.finished_at).getTime() - new Date(attempt.started_at).getTime() > 0
                          ? new Date(new Date(attempt.finished_at).getTime() - new Date(attempt.started_at).getTime())
                              .toISOString()
                              .substring(11, 19)
                          : "00:00:00"}
                      </Table.Td>
                      <Table.Td>
                          <Badge
                          color={attempt.is_approved ? "green" : "red"}
                          variant="filled"
                          >
                            {attempt.is_approved ? t("quiz.approved") : t("quiz.failed")}
                          </Badge>
                      </Table.Td>
                    </Table.Tr>
                ))}
                </Table.Tbody>
            </Table>
        </ScrollArea>
      )}
    </>
  );
};
